import _ from "../../packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js";
import { loc } from "./loc.js";
import Enums from "./Enums.js";
import Logger from "./Logger.js";
import fn from "./BrowserFeatures.js";
const Util = {};
const ovDeepLink = "redirect_uri=https://login.okta.com/oauth/callback";
const buildInputForParameter = function(name, value) {
  const input = document.createElement("input");
  input.name = name;
  input.value = decodeURIComponent(value);
  input.type = "hidden";
  return input;
};
const buildSubmitInput = function() {
  const input = document.createElement("input");
  input.type = "submit";
  return input;
};
const buildDynamicForm = function(url = "", method) {
  const splitOnFragment = url.split("#");
  const fragment = splitOnFragment[1];
  const splitOnQuery = (splitOnFragment[0] || "").split("?");
  const query = splitOnQuery[1];
  let targetUrl = splitOnQuery[0];
  if (fragment) {
    targetUrl += "#" + fragment;
  }
  const form = document.createElement("form");
  form.method = method;
  form.style.display = "none";
  form.action = targetUrl;
  if (query && query.length) {
    const queryParts = query.split("&");
    queryParts.forEach((queryPart) => {
      const parameterParts = queryPart.split("=");
      const input = buildInputForParameter(parameterParts[0], parameterParts[1]);
      form.appendChild(input);
    });
  }
  form.appendChild(buildSubmitInput());
  return form;
};
Util.transformErrorXHR = function(xhr) {
  if (xhr.status === 0 && _.isEmpty(xhr.responseJSON)) {
    xhr.responseJSON = {
      errorSummary: loc("error.network.connection", "login")
    };
    return xhr;
  }
  if (!xhr.responseJSON) {
    if (!xhr.responseText) {
      xhr.responseJSON = {
        errorSummary: loc("error.unsupported.response", "login")
      };
      return xhr;
    }
    if (typeof xhr.responseText === "string") {
      try {
        xhr.responseJSON = JSON.parse(xhr.responseText);
      } catch (e) {
        xhr.responseJSON = {
          errorSummary: loc("error.unsupported.response", "login")
        };
        return xhr;
      }
    } else if (typeof xhr.responseText === "object") {
      xhr.responseJSON = xhr.responseText;
    }
  }
  if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
    xhr.responseJSON.errorSummary = xhr.responseJSON.errorCauses[0].errorSummary;
  }
  if (!_.isEmpty(xhr.responseJSON)) {
    const {
      errorCode
    } = xhr.responseJSON;
    const untranslatedErrorCodes = [
      // API already provides localized and factor specific error message in errorCauses
      "E0000068",
      // API provides localized error message for password requirements in errorCauses
      "E0000014"
    ];
    const errorMsg = errorCode && !untranslatedErrorCodes.includes(errorCode) ? loc("errors." + errorCode, "login", [], true) : void 0;
    if ((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.indexOf("L10N_ERROR[")) === -1) {
      xhr.responseJSON.errorSummary = errorMsg;
      if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
        delete xhr.responseJSON.errorCauses;
      }
    }
  }
  return xhr;
};
Util.toLower = function(strings) {
  return _.map(strings, function(str) {
    return str.toLowerCase();
  });
};
function expandLanguage(language) {
  const expanded = [language];
  const parts = language.split("-");
  while (parts.pop() && parts.length > 0) {
    expanded.push(parts.join("-"));
  }
  return expanded;
}
Util.expandLanguages = function(languages) {
  return _.chain(languages).map(expandLanguage).flatten().uniq().value();
};
Util.callAfterTimeout = function(callback, time) {
  return setTimeout(callback, time);
};
Util.debugMessage = function(message) {
  Logger.warn(`
${message.replace(/^(\s)+/gm, "")}`);
};
Util.logConsoleError = function(message) {
  Logger.error(message);
};
Util.triggerAfterError = function(controller, err = {}) {
  if (!err.statusCode && err.xhr && err.xhr.status) {
    err.statusCode = err.xhr.status;
  }
  const className = _.isFunction(controller.className) ? controller.className() : controller.className;
  const error = _.pick(err, "name", "message", "statusCode", "xhr");
  controller.trigger("afterError", {
    controller: className
  }, error);
  Logger.warn("controller: " + className + ", error: " + error);
};
Util.redirect = function(url, win = window, isAppLink = false) {
  if (fn.isAndroid() && !isAppLink) {
    Util.redirectWithFormGet(url);
  } else {
    Util.changeLocation(url, win);
  }
};
Util.changeLocation = function(url, win = window) {
  if (!url) {
    Logger.error(`Cannot redirect to empty URL: (${url})`);
    return;
  }
  win.location.href = url;
};
Util.executeOnVisiblePage = function(cb) {
  if (document.visibilityState === "hidden") {
    const visibilityChangeHandler = () => {
      if (document.visibilityState === "visible") {
        document.removeEventListener("visibilitychange", visibilityChangeHandler);
        cb();
      }
    };
    document.addEventListener("visibilitychange", visibilityChangeHandler);
  } else {
    cb();
  }
};
Util.isAndroidOVEnrollment = function() {
  const ovEnrollment = decodeURIComponent(window.location.href).includes(ovDeepLink);
  return fn.isAndroid() && ovEnrollment;
};
Util.redirectWithFormGet = function(url) {
  Util.redirectWithForm(url, "get");
};
Util.redirectWithForm = function(url, method = "post") {
  if (!url) {
    Logger.error(`Cannot redirect to empty URL: (${url})`);
    return;
  }
  const mainContainer = document.getElementById(Enums.WIDGET_CONTAINER_ID);
  if (!mainContainer) {
    Logger.error("Cannot find okta-sign-in container append to which a form");
    return;
  }
  const form = buildDynamicForm(url, method);
  mainContainer.appendChild(form);
  form.querySelector('input[type="submit"]').click();
};
Util.createInputExplain = function(explainKey, labelKey, bundleName, explainParams, labelParams) {
  const explain = explainParams ? loc(explainKey, bundleName, explainParams) : loc(explainKey, bundleName);
  const label = labelParams ? loc(labelKey, bundleName, labelParams) : loc(labelKey, bundleName);
  if (explain === label) {
    return false;
  }
  return explain;
};
Util.isV1StateToken = function(token) {
  return !!(token && _.isString(token) && token.startsWith("00"));
};
Util.getAutocompleteValue = function(settings, defaultValue) {
  const shouldDisableAutocomplete = settings === null || settings === void 0 ? void 0 : settings.get("features.disableAutocomplete");
  if (shouldDisableAutocomplete) {
    return "off";
  }
  return defaultValue;
};
Util.searchParamsToString = function(params) {
  return Object.keys(params).filter((key) => {
    const val = params[key];
    return val !== void 0 && val !== null;
  }).map((key) => {
    return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
  }).join("&");
};
export { Util as default };
